"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const PropertyBuilder = require('../propertyBuilder');
const uuid = require('uuid');
const TrackingPreferences = require('../helpers/fetchTrackingPreferences');
const {
  removeAllHyphens
} = require('../utils/stringUtils');
const {
  commonEventProperties
} = require('../constants');
const create = (writeKey, eventName, _ref) => {
  let {
    properties,
    culture,
    tenant,
    sharedPayload
  } = _ref;
  const timestamp = new Date();
  properties = getProperties(properties, culture, tenant, eventName);
  const categoryPreferences = TrackingPreferences.getCategoryPreferences();
  if (categoryPreferences) {
    sharedPayload.context = _objectSpread(_objectSpread({}, sharedPayload.context), {}, {
      consent: {
        categoryPreferences
      }
    });
  }
  const payload = _objectSpread(_objectSpread({}, sharedPayload), {}, {
    event: eventName,
    type: 'track',
    properties,
    timestamp,
    writeKey: writeKey,
    messageId: generateMessageId()
  });
  return payload;
};
const addConnectionInformation = properties => {
  // navigator.connection is not supported by Safari
  // eslint-disable-next-line compat/compat
  const connectionInfo = window?.navigator?.connection;
  if (!connectionInfo) {
    return properties;
  }
  const {
    rtt,
    effectiveType,
    downlink
  } = connectionInfo;
  const connection = {
    rtt,
    downlink,
    effectiveType
  };
  return _objectSpread(_objectSpread({}, properties), {}, {
    connection
  });
};
const getProperties = (properties, culture, tenant, eventName) => {
  properties = PropertyBuilder.create(properties, culture, tenant).addVisit().addPtid().addPageViewId().addMetatagValues(commonEventProperties).addLanguageLocale('track', eventName).addTrackingInfo().addTestUserId().getProperties();
  properties = addConnectionInformation(properties);
  return properties;
};
const generateMessageId = () => `ajs-next-${removeAllHyphens(uuid.v4())}`;
module.exports = {
  create
};